import React from "react"
import { Button, ButtonProps } from "@chakra-ui/react"
import { useCart } from "@hooks/useCart"
import { useAppContext } from "@providers/app"

export interface ProductAddToCartProps extends ButtonProps {
  loading: boolean
  product?: any
  variant?: any
  quantity?: number
  onAddToCart?: VoidFunction
  customAttributes?: Array<CustomAttribute>
  isFormValid?: boolean
}

const ProductAddToCart = ({ loading, product, variant, quantity = 1, onAddToCart, customAttributes = [], isFormValid, ...props }: ProductAddToCartProps) => {
  const { addToCart, loading: cartLoading } = useCart()
  const { activeVariant, dispatch } = useAppContext()

  const triggerMiniCart = () => {
    dispatch({
      type: "cart",
      payload: {
        activeCart: true,
        addedToCart: true,
      },
    })
  }

  const handleAddToCart = () =>
    addToCart(product, variant?.id ? variant : activeVariant?.id ? activeVariant : {}, quantity, customAttributes).then(() => {
      onAddToCart && onAddToCart()
      triggerMiniCart()
    })

  const isDisabled = React.useMemo(() => {
    return !activeVariant?.availableForSale || loading || isFormValid === false
  }, [activeVariant?.availableForSale, isFormValid, loading])

  return <Button onClick={handleAddToCart} size="lg" disabled={isDisabled} isLoading={cartLoading} {...props} />
}

export default React.memo(ProductAddToCart)
